import {
	Typography,
	Stack,
	InputLabel,
	MenuItem,
	Select,
	Icon,
	FormControl,
} from '@mui/material';

import React, { useState } from 'react';

import { ReactComponent as ArrowRightIcon } from 'common/assets/images/arrow-right-big.svg';
import { ReactComponent as ExpandMoreRoundedIcon } from 'common/assets/images/select-chevron.svg';
import {
	COLUMNS_IN_YOUR_FILE,
	IColumnMappingData,
	REQUIRED_FIELD,
	SELECT_COLUMN_LABEL,
	FILE_UPLOAD_REQUIRED_FIELDS,
} from 'common/constants/AISimulationConstants';

import styles from './AIModalColumnMapping.module.scss';

interface IAIModalColumnMappingProps {
	values: any;
	handleSelection: (key: string, e: any, item: any) => void;
}
const AIModalColumnMapping = (props: IAIModalColumnMappingProps) => {
	const { values, handleSelection } = props;
	const [selectedValue, setSelectedValue] = useState<boolean>(false);

	return (
		<div data-testid="aimodal-column-mapping-container">
			<Stack className={styles['column-mapping-heading-label']}>
				{FILE_UPLOAD_REQUIRED_FIELDS}
			</Stack>
			<Stack direction="row" className={styles['column-mapping-heading-stack']}>
				<InputLabel id="demo" className={styles['column-mapping-heading-text']}>
					{REQUIRED_FIELD}
				</InputLabel>

				<InputLabel id="demo" className={styles['column-mapping-heading-text']}>
					{COLUMNS_IN_YOUR_FILE}
				</InputLabel>
			</Stack>
			{values?.map((item: IColumnMappingData) => (
				<Stack
					key={item?.label}
					direction="row"
					className={styles['column-mapping-stack']}
				>
					<Stack className={styles['column-mapping-container-columntext']}>
						<Typography
							className={styles['column-mapping-container-columntext-color']}
						>
							{item?.label}
						</Typography>
					</Stack>
					<Stack className={styles['column-mapping-container-icon']}>
						<Icon>
							<ArrowRightIcon className={styles['column-mapping-fileicon']} />
						</Icon>
					</Stack>
					<Stack className={styles['column-mapping-container-select']}>
						<FormControl data-testid="form-control" sx={{ minWidth: '45%' }}>
							<InputLabel
								id="demo"
								className={
									!selectedValue
										? styles['fileupload-select']
										: styles['fileupload-select-selected']
								}
								sx={{
									'&.Mui-focused': {
										marginTop: '10px',
									},
								}}
							>
								{SELECT_COLUMN_LABEL}
								<span className={styles['fileupload-datatype-required']}>
									{' '}
									*
								</span>
							</InputLabel>
							<Select
								IconComponent={ExpandMoreRoundedIcon}
								labelId="demo"
								sx={{
									zIndex: 1300,
									width: '100%',
								}}
								onChange={(e) => {
									handleSelection(item?.key, e?.target?.value, item);
									setSelectedValue(true);
								}}
								inputProps={{
									'data-testid': 'datatype-ele',
								}}
							>
								{item?.value?.map((data: any) => (
									<MenuItem value={data} key={data}>
										<div data-testid="dropdown-value-selected">{data}</div>
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Stack>
				</Stack>
			))}
		</div>
	);
};
export default AIModalColumnMapping;
